export const css = {
	list: '_7GQCxnXN',
	listItem: 'EL574NVr',
	listLeadingOverride: 'D61kPW9D',
	listLeading: '_5iDJFAJQ',
	listCenterOverride: 'kN8en7S5',
	listCenter: 'fYayB3Jh',
	listItemTitle: '_7s-X9k58',
	listItemTitleText: 'xmCaacZy',
	listTrailingOverride: 'hY555JMi',
	actions: 'SHAO-PFz',
	' _key': 'mc-widgets/list-view'
};

export default css;
